import React from 'react'
import { LayoutDialogProps } from './LayoutDialog.types'
import styles from './LayoutDialog.module.scss'
// import cl from 'classnames'
import {
  Button,
  CloseButton,
  Numbers,
  PopupContainer,
  SectionContainer,
  Text1
} from 'components/shared'
import { DragDropSection } from './DragDropSection'
import { useLayoutSections } from './LayoutDialog.utils'
import { inject } from 'mobx-react'
import { DASHBOARD_PAGE_STORE } from 'store'

const LayoutDialogComponent = (props: LayoutDialogProps) => {
  const {
    className,
    style,
    closeDialog,
    [DASHBOARD_PAGE_STORE]: {
      cardsSettings,
      layoutSettings,
      onSaveLayoutClick
    }
  } = props

  const { layoutSections, onDragEnd, getSettings } = useLayoutSections(layoutSettings, cardsSettings)

  const onSaveClick = () => {
    const {
      cardsSettings,
      layoutSettings
    } = getSettings()
    onSaveLayoutClick(layoutSettings, cardsSettings)
    closeDialog()
  }

  return (
    <PopupContainer>
      <SectionContainer
        extraPaddingBottom
        className={className}
        style={style}
      >
        <Numbers>
          Customize dashboard
        </Numbers>
        <Text1 style={{ marginTop: 16 }}>
          Choose which components you would like to see
          on your dashboard and drag them to change their order.
        </Text1>

        <DragDropSection
          onDragEnd={onDragEnd}
          draggableSections={layoutSections}
          className={styles.container}
        />

        <div className={styles.buttonsContainer}>
          <Button
            preset='secondary'
            onClick={closeDialog}
          >
            Cancel
          </Button>
          <Button
            preset='primary'
            onClick={onSaveClick}
          >
            Save
          </Button>
        </div>

        <CloseButton
          className={styles.closeButton}
          onClick={closeDialog}
        />

      </SectionContainer>
    </PopupContainer>
  )
}

const LayoutDialog = inject(
  DASHBOARD_PAGE_STORE
)(LayoutDialogComponent)
export { LayoutDialog }
